<template>
  <div class="unmannedAerialVehicle">
    <div class="productBox">
      <div
        class="contentItemBox"
        v-for="(item, index) in productList"
        :key="index"
        @click="toProductDetail(item)"
      >
        <img class="imgBox" :src="item.img" alt="" />
        <div class="conItem">{{ item.title }}</div>
      </div>
    </div>
    <el-backtop></el-backtop>
  </div>
</template>

<script>
export default {
  data () {
    return {
      productList: []
    }
  },
  created () {
    this.productList = JSON.parse(
      window.sessionStorage.getItem('unmannedAerialVehicleObj')
    )
  },
  methods: {
    toProductDetail (item) {
      this.$router.push({
        path: '/unmannedAerialVehicleDetail',
        query: {
          id: item.id
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.unmannedAerialVehicle {
  height: 100%;
  width: 100%;
  background-color: #f6f6f6;
  .productBox {
    width: 900px;
    margin: 0 auto;
    padding: 20px 0px;
    display: flex;
    flex-wrap: wrap;
    // justify-content: center;

    .contentItemBox {
      width: 260px;
      height: 300px;
      background-color: #fff;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: space-evenly;
      margin: 20px;
      cursor: pointer;
      transition: all 0.5s;
      box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      font-size: 14px;
      .imgBox {
        width: 150px;
        height: 100px;
      }
      .conItem {
        border: 1px solid #2b7fd9;
        border-radius: 20px;
        text-align: center;
        padding: 5px 10px;
        color: #2b7fd9;
      }
      .conItem:hover {
        background-color: #d8e7f8;
      }
      .conText {
        text-align: center;
        padding: 0 10px;
      }
    }
    .contentItemBox:hover {
      scale: 1.1;
      transition: all 0.5s;
    }
  }
}
</style>
